module.exports = __webpack_public_path__ + "1db879d6078c0d9bd3f6fcc00954a76b.png";